var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.18681 18C0.87033 18 0.593406 17.8773 0.356044 17.6318C0.118681 17.3864 0 17.1 0 16.7727V1.22727C0 0.9 0.118681 0.613636 0.356044 0.368182C0.593406 0.122727 0.87033 0 1.18681 0H9.89011C10.2066 0 10.4835 0.122727 10.7209 0.368182C10.9582 0.613636 11.0769 0.9 11.0769 1.22727V16.7727C11.0769 17.1 10.9582 17.3864 10.7209 17.6318C10.4835 17.8773 10.2066 18 9.89011 18H1.18681ZM1.18681 14.9318V16.7727H9.89011V14.9318H1.18681ZM5.53846 16.4659C5.70989 16.4659 5.85165 16.408 5.96374 16.292C6.07582 16.1761 6.13187 16.0295 6.13187 15.8523C6.13187 15.675 6.07582 15.5284 5.96374 15.4125C5.85165 15.2966 5.70989 15.2386 5.53846 15.2386C5.36703 15.2386 5.22527 15.2966 5.11319 15.4125C5.0011 15.5284 4.94506 15.675 4.94506 15.8523C4.94506 16.0295 5.0011 16.1761 5.11319 16.292C5.22527 16.408 5.36703 16.4659 5.53846 16.4659ZM1.18681 13.7045H9.89011V3.06818H1.18681V13.7045ZM1.18681 1.84091H9.89011V1.22727H1.18681V1.84091ZM1.18681 14.9318V16.7727V14.9318ZM1.18681 1.84091V1.22727V1.84091Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneShare);
export default __webpack_public_path__ + "static/media/phoneShare.adea02cf66723db0ce58b1c5e667743c.svg";
export { ForwardRef as ReactComponent };